import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    downloadDialog: false,
    logo: '',
    loginLogo: '',
    denyListCurrentStationIds: [],
    dictionary: JSON.parse(sessionStorage.dictionary || '{}'),
    emsStationCode: '11010100001',
  },
  getters,
  actions,
  mutations,
});
export default store;
